(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tecDotLoadingBound) return;
    window.__tecDotLoadingBound = true;

    var timers = new WeakMap();

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.tec-dot-loading-btn');
      if (!button) return;

      if (timers.has(button)) {
        window.clearTimeout(timers.get(button));
      }

      button.classList.add('is-loading');

      var timeoutId = window.setTimeout(function () {
        button.classList.remove('is-loading');
        timers.delete(button);
      }, 1200);

      timers.set(button, timeoutId);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
